<template>

    <v-dialog v-model="open" max-width="700px" @click:outside="close">

        <v-card>
            <v-card-title>
                <span class="headline">{{ title }}</span>
            </v-card-title>

            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12" sm="6" md="12">
                            <v-text-field v-model="value.email" label="Email Adresse"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="12">
                            <v-text-field v-model="value.password" label="Passwort" type="password"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <v-text-field v-model="value.firstname" label="Vorname"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <v-text-field v-model="value.lastname" label="Nachname"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                            <v-switch v-model="value.enabled" label="Aktiviert"></v-switch>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                            <v-switch v-model="value.emailVerified" label="Email verifiziert"></v-switch>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                            <v-select cache-items :items="roles" :loading="roleLoading" v-model="value.roleId" label="Rolle"></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                            <v-autocomplete :items="visors" :loading="visorsLoading" :value="value.visorId == null ? 0 : value.visorId" v-model="value.visorId" label="Visierer"></v-autocomplete>
                        </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-autocomplete :items="organisationalUnits" :loading="organisationalUnitsLoading" :value="value.organisationalUnitId == null ? 0 : value.organisationalUnitId" v-model="value.organisationalUnitId" label="Organisationseinheit"></v-autocomplete>
                      </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">Abbrechen</v-btn>
                <v-btn color="success darken-1" text @click="save">Speichern</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

    import {accountService} from "../services/accountService";

    export default {
        name: "UserModal",
        props: ["value", "open", "title"],
        data: () => {
            return {
                roleLoading: true,
                roles: [],
              organisationalUnits: [],
              organisationalUnitsLoading: true,
                visorsLoading: true,
                visors: [],
            };
        },
        methods: {
            save() {
                this.$emit("input", this.value)
                this.$emit('save');
                this.close();
            },
            close() {
                this.$emit('close');
            },
        },
        created() {
            this.account = this.value;
            let self = this;
            accountService.getRoles().then(value => {
                for(let i = 0; i < value.length; i++) {
                    self.roles.push({
                        text: value[i].name,
                        value: value[i].id,
                    });
                }
                self.roleLoading = false;
            });

          accountService.getOrganisationalUnits().then(value => {
            for(let i = 0; i < value.length; i++) {
              self.organisationalUnits.push({
                text: value[i].name,
                value: value[i].id,
              });
            }
            self.organisationalUnitsLoading = false;
          });

            accountService.getQuery("roleId=2").then(value => {
                for(let i = 0; i < value.length; i++) {
                    self.visors.push({
                        text: value[i].firstname + " " + value[i].lastname,
                        value: value[i].id,
                    });
                }
                self.visorsLoading = false;
            })
        }
    }
</script>

<style scoped>

</style>